import { z } from 'zod'
import { queryDateTime } from '../common/query-date'

export const transfersQuerySchema = z.object({
  startDate: queryDateTime,
  endDate: queryDateTime,
})

export type TransfersQueryDto = z.infer<typeof transfersQuerySchema>
